import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from 'src/app/core/services/rest.service';
import { ApiResult } from 'src/app/core/models/api-result.model';

export interface OnboardingState {
  subscribed: boolean;
  snoozed: boolean;
  dismissed: boolean;
  icalUrl: string | null;
}

@Injectable({ providedIn: 'root' })
export class IcalOnboardingService {
  constructor(private rs: RestService) {}

  getState(): Observable<OnboardingState | null> {
    return this.rs.get_api('alerts/onboarding-state').pipe(
      map((res: ApiResult) => {
        if (!res?.success || !res.result) return null;
        return {
          subscribed: !!res.result.subscribed,
          snoozed: !!res.result.snoozed,
          dismissed: !!res.result.dismissed,
          icalUrl: res.result.icalUrl ?? null,
        };
      })
    );
  }

  snooze(): Observable<boolean> {
    return this.rs
      .post_api('alerts/snooze-banner', {})
      .pipe(map((res: ApiResult) => !!res?.success));
  }

  dismiss(): Observable<boolean> {
    return this.rs
      .post_api('alerts/dismiss-banner', {})
      .pipe(map((res: ApiResult) => !!res?.success));
  }

  shouldShowBanner(state: OnboardingState | null): boolean {
    if (!state) return false;
    return !state.subscribed && !state.snoozed && !state.dismissed;
  }
}
